import { AuthService } from './../../../base/services/auth.service';
import { ExportInterfaceExecutionLogClient } from './../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientDTO, FilterDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';

@Injectable()
export class HistoryService extends ShowInactiveService implements IAdaptorService {

  public selectedClient: ClientDTO;

  constructor(
    private logClient: ExportInterfaceExecutionLogClient,
    private authService: AuthService
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    const client = this.authService.getUserInfo()?.client;
    if (client) {
      this.selectedClient = client;
    }
    if (!sortBy) {
      sortBy = 'Timestamp';
      sortDirection = SortDirection.Descending;
    }
    return this.logClient.searchExportInterfaceExecutionLogs(this.selectedClient?.id, skip, take, sortBy, sortDirection, false, filters);
  }
  
  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  
  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  
  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

}
